import React from "react";
import BreadCrumb from "../../../Common/BreadCrumb";

const Videos = () => {
  return (
    <React.Fragment>
      <BreadCrumb title="Videos" pageType="Elements" />

      <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
        <div className="grid grid-cols-1 gap-4">
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Aspect Auto Videos
            </h2>
            <div>
              <iframe
              title="abc1"
                className="w-full md:aspect-video lg:aspect-auto"
                src="https://www.youtube.com/embed/-GfNEDs3ERw"
              ></iframe>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Aspect Videos
            </h2>
            <div>
              <iframe
              title="abc2"
                className="w-full md:aspect-square lg:aspect-video"
                src="https://www.youtube.com/embed/-GfNEDs3ERw"
              ></iframe>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Aspect Square Videos
            </h2>
            <div>
              <iframe
              title="abc3"
                className="w-full aspect-square"
                src="https://www.youtube.com/embed/-GfNEDs3ERw"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Videos;
